// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_di-b";
export var colorBlue = "_di-8";
export var colorDot = "_di-0";
export var colorDotLarge = "_di-2";
export var colorDotSmall = "_di-1";
export var colorGreen = "_di-7";
export var colorGrey = "_di-3";
export var colorOrange = "_di-5";
export var colorPink = "_di-a";
export var colorPurple = "_di-9";
export var colorRed = "_di-4";
export var colorYellow = "_di-6";